/* unplugin-vue-components disabled */import script from "./School.vue?vue&type=script&setup=true&lang=ts"
export * from "./School.vue?vue&type=script&setup=true&lang=ts"

import "./School.vue?vue&type=style&index=0&id=4de8571a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de8571a"]])

export default __exports__